import { useForm } from 'react-hook-form'
import { capitalizeString } from 'src/utils/capitalize'
import { useDispatch } from 'react-redux'
import { actions } from '../../../../RestockingState'
import { useState } from 'react'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import Modal from 'src/components/Modal'
import * as S from './ReportQuantityPerBoxDivergentModal.styles'
import { useHistory } from 'react-router-dom'

interface ReportQuantityPerBoxDivergentModalProps {
  show: boolean
  productDescription: string
  badge: string
  idItem: number
  onClose: () => any
}

interface FormData {
  newQuantityPerBox: number | null;
}

const ReportQuantityPerBoxDivergentModal: React.FC<ReportQuantityPerBoxDivergentModalProps> = (
  {
    show, productDescription, badge, idItem, onClose,
  },
) => {
  const [openModalConfirmationNewQuantityPerBox, setOpenModalConfirmationNewQuantityPerBox] = useState(false)

  const {
    register,
    reset,
    handleSubmit,
    clearErrors,
    getValues,
    formState: { errors },
  } = useForm<FormData>()

  const dispatch = useDispatch()
  const history = useHistory()

  const clearForm = () => {
    clearErrors('newQuantityPerBox')
    reset({ newQuantityPerBox: null })
  }

  const closeModalReportQuantityPerBox = () => {
    clearForm()
    onClose()
  }

  const openModalConfirmation = () => setOpenModalConfirmationNewQuantityPerBox(true)
  const closeModalConfirmation = () => setOpenModalConfirmationNewQuantityPerBox(false)

  const onSubmitNewQuantityPerBox = () => {
    const { newQuantityPerBox } = getValues()

    if (!newQuantityPerBox) return

    dispatch(actions.restockingReportQuantityPerBox({
      badge,
      idItem,
      newQuantityPerBox,
      history,
    }))

    closeModalReportQuantityPerBox()
    closeModalConfirmation()
  }

  return (
    <>
      {
        !openModalConfirmationNewQuantityPerBox && (
          <Modal
            show={show}
            testId='modal-report-quantity-per-box-divergent-test-id'
            centered
            title='Reportar caixaria divergente'
            closeButtonAction={closeModalReportQuantityPerBox}
            closedButton
            body={(
              <S.Container onSubmit={handleSubmit(openModalConfirmation)}>
                <S.CustomTypography>
                  Informe a nova caixaria do produto: <strong>{capitalizeString(productDescription)}</strong>
                </S.CustomTypography>
                <S.CustomTextField
                  id='newQuantityPerBox'
                  name='newQuantityPerBox'
                  type='number'
                  autoComplete='off'
                  autoFocus
                  inputProps={{
                    ...register('newQuantityPerBox', {
                      required: 'Informe a nova caixaria!',
                      validate: {
                        positive: (value) => (value && value > 0) || 'Informe um valor maior que zero!',
                      },
                    }),
                    'data-testid': 'new-quantity-per-box-input-test-id',
                  }}
                  error={!!errors.newQuantityPerBox}
                  label='quantity.per.box'
                  helperText={!!errors.newQuantityPerBox && errors.newQuantityPerBox.message}
                  fullWidth
                  size='medium'
                />
                <S.ContainerButton>
                  <S.CustomButton
                    type='submit'
                    id='save-quantity-per-box-divergent-button'
                    title='Salvar'
                    bgColor='confirm'
                    hoverColor='confirmHover'
                    letterColor='white'
                    data-testid='save-quantity-per-box-divergent-button-test-id'
                  />
                  <S.CustomButton
                    title='Cancelar'
                    bgColor='cancel'
                    hoverColor='cancelHover'
                    letterColor='white'
                    data-testid='cancel-quantity-per-box-divergent-button-test-id'
                    onClick={closeModalReportQuantityPerBox}
                  />
                </S.ContainerButton>
              </S.Container>
              )}
          />
        )
      }
      <ConfirmOrRejectModal
        show={openModalConfirmationNewQuantityPerBox}
        title='Confirmação nova caixaria'
        customizableDescription={(
          <S.ContainerDescription>
            <p>
              A Caixaria do produto <strong>{capitalizeString(productDescription)}</strong>,
              será alterada para: <strong>{getValues('newQuantityPerBox')}</strong>.
            </p>
            <p>
              Deseja prosseguir?
            </p>
          </S.ContainerDescription>
            )}
        onConfirm={onSubmitNewQuantityPerBox}
        onReject={closeModalConfirmation}
        onClose={closeModalConfirmation}
        dataTestId='modal-confirmation-new-quantity-per-box-test-id'
      />
    </>
  )
}

export default ReportQuantityPerBoxDivergentModal
